import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledModal,
  ButtonContainer,
  StyledModalHeader,
  MainButton,
} from '../../form/FormElements';
import { Input } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function QuestionModal({
  visible,
  toggle,
  headerTitle,
  question,
  chosenPositive,
  yes,
  isNote,
  showDefaultButtons = true,
  customButtons,
  yesDisabled,
  yesLoading,
  yesDanger,
}) {
  const [note, setNote] = useState('');
  const { t } = useTranslation();
  return (
    <StyledModal
      open={visible}
      centered
      size="xs"
      onCancel={() => toggle()}
      footer={null}
    >
      <StyledModalHeader>
        <span className="second-title">{headerTitle}</span>
      </StyledModalHeader>

      <article style={{ padding: '0px 0px 20px 0px' }}>{question}</article>

      {isNote ? (
        <Input.TextArea
          name={'note'}
          value={note}
          placeholder={t('Poznámka')}
          onChange={(e) => setNote(e.target.value)}
        />
      ) : (
        []
      )}

      {showDefaultButtons ? (
        <ButtonContainer>
          <MainButton onClick={() => toggle()}>{t('Zrušiť')}</MainButton>
          <MainButton
            disabled={yesDisabled}
            loading={yesLoading}
            danger={yesDanger}
            onClick={() => {
              chosenPositive(note);
              toggle();
              setNote('');
            }}
          >
            {yes ? yes : t('Áno')}
          </MainButton>
        </ButtonContainer>
      ) : customButtons ? (
        <ButtonContainer>{customButtons}</ButtonContainer>
      ) : null}
    </StyledModal>
  );
}

QuestionModal.propTypes = {
  visible: PropTypes.bool,
  toggle: PropTypes.func,
  headerTitle: PropTypes.string,
  question: PropTypes.node,
  yes: PropTypes.string,
  chosenPositive: PropTypes.func, // funkcia ako callback z rodicovskeho componentu co sa ma stat ak da ano
  isNote: PropTypes.bool,
  showDefaultButtons: PropTypes.bool,
  customButtons: PropTypes.node,
  yesDisabled: PropTypes.bool,
  yesLoading: PropTypes.bool,
  yesDanger: PropTypes.bool,
};

export default QuestionModal;
